import { render, staticRenderFns } from "./page-documents.vue?vue&type=template&id=6a33e88b&"
import script from "./page-documents.vue?vue&type=script&lang=ts&"
export * from "./page-documents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports